<template>
  <div id="app">
    
    <router-view/>
  </div>

</template>


<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  mounted () {
    console.log('app111');
  },
  methods: {

  }
}

</script>

<style rel="stylesheet/scss" lang="scss">
  .el-message {
    width: 450px;
    font-size: 32px;
    .el-message__content {
      font-size: 32px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue